import { Directive, HostBinding, Input } from '@angular/core';
import { NotificationAlertLevel } from '../notification-alert-level.enum';

@Directive({
    selector: '[appBannerNotificationIcon]',
    standalone: false
})
export class BannerNotificationIconDirective {

  @Input() set alertLevel(level: NotificationAlertLevel) {
    this.iconType = this.getIconType(level)
  }

  @HostBinding('innerText') iconType = '';

  constructor() {
  }

  private getIconType(level: NotificationAlertLevel) {
    switch (level) {
      case NotificationAlertLevel.Error: return 'error'
      case NotificationAlertLevel.Success: return 'check_circle'
      case NotificationAlertLevel.Info: return 'info'
      case NotificationAlertLevel.Warning: return 'warning'
      case NotificationAlertLevel.Lead: return 'notifications'
      default: return 'notifications'
    }
  }

}
